import React from "react";

function AuthOption() {
  return (
    <div className="d-flex col-2 ">
      <button className="btn btn-outline-light mx-3 " type="submit">
        <a href="/login">Login</a>
      </button>
      <button className="btn btn-outline-light" type="submit">
        <a href="login.html">Signup</a>
      </button>
    </div>
  );
}

export default AuthOption;
